import {Component, OnInit} from '@angular/core';
import {PortfolioItem, PortfolioList, PortolioCategories} from "./portfolio.datatypes";
import {PortfolioService} from "./portfolio-service.service";
import 'bootstrap';
import * as _ from 'underscore';

@Component({
    selector: 'app-portfolio',
    templateUrl: './portfolio.component.html',
    styleUrls: ['./portfolio.component.css']
})
export class PortfolioComponent implements OnInit {

    public portfolio: PortfolioList[];
    public config: any;
    public errorMsg: string;
    public portfolioItems: PortfolioList[];
    private portfolioCategories: PortolioCategories;

    constructor(private portfolioService: PortfolioService) {
    }

    ngOnInit() {
        this.portfolioService.config.subscribe((config) => {
            this.config = config;
        });
        this.portfolioService.portfolioList.subscribe((items) => {
            this.portfolioItems = items;
            this.portfolio = _.clone(items);
        });
        this.portfolioService.portfolioCategories.subscribe((items) => {
            this.portfolioCategories = items;
        });

        this.portfolioService.currentList.subscribe((items) => {
            this.updatePortfolioList(items);
        })
    }

    private updatePortfolioList(keys: string[]): void {
        if (!this.portfolio) return;
        if (!keys || keys.length == 0) {
            this.portfolioItems = this.portfolio;
        } else {
            this.portfolioItems = this.portfolio.filter((item: PortfolioItem) => {
                let arr = _.intersection(item.icons.split(','), keys);
                return arr.length > 0;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/portfolio/portfolio.component.ts